const VIEWPORT_PADDING = 8;

const clamp = ({ value, min, max }) => Math.min(Math.max(value, min), max);

/**
 * Chooses panel placement around the tasks button and clamps it inside the viewport.
 */
export const getNotificationsPanelPlacement = ({
  buttonRect,
  panelWidth,
  panelHeight,
  gap = 4,
  viewport = {
    width: window.innerWidth,
    height: window.innerHeight,
  },
}) => {
  const spaceBelow =
    viewport.height - buttonRect.bottom - gap - VIEWPORT_PADDING;
  const spaceAbove = buttonRect.top - gap - VIEWPORT_PADDING;
  const spaceLeft = buttonRect.left - gap - VIEWPORT_PADDING;
  const spaceRight = viewport.width - buttonRect.right - gap - VIEWPORT_PADDING;

  let top;
  let left = buttonRect.right - panelWidth;

  if (spaceBelow >= panelHeight) {
    top = buttonRect.bottom + gap;
  } else if (spaceAbove >= panelHeight) {
    top = buttonRect.top - gap - panelHeight;
  } else if (spaceLeft >= panelWidth) {
    top = buttonRect.top + buttonRect.height / 2 - panelHeight / 2;
    left = buttonRect.left - gap - panelWidth;
  } else if (spaceRight >= panelWidth) {
    top = buttonRect.top + buttonRect.height / 2 - panelHeight / 2;
    left = buttonRect.right + gap;
  } else {
    top = buttonRect.bottom + gap;
    left = buttonRect.right - panelWidth;
  }

  top = clamp({
    value: top,
    min: VIEWPORT_PADDING,
    max: viewport.height - panelHeight - VIEWPORT_PADDING,
  });
  left = clamp({
    value: left,
    min: VIEWPORT_PADDING,
    max: viewport.width - panelWidth - VIEWPORT_PADDING,
  });

  return { top, left };
};
